'use strict';

/**
 * Lets the mouse wheel scroll a horizontally-scrolling element, since
 * vertical wheel input otherwise does nothing on an element with only
 * horizontal overflow.
 */
const HorizontalWheelScrollDir = {
    bind: function (el) {
        if (el.$athHorizontalWheelScroll) return;

        const onWheel = (event) => {
            if (!event.deltaY) return;

            //  Let the page scroll once there is no more horizontal room in the wheel's direction
            const maxScrollLeft = el.scrollWidth - el.clientWidth;
            const delta = event.deltaY + event.deltaX;
            if (delta < 0 && el.scrollLeft <= 0) return;
            if (delta > 0 && el.scrollLeft >= maxScrollLeft - 1) return;

            el.scrollLeft += delta;
            event.preventDefault();
        };

        //  Non-passive so preventDefault can stop the page from scrolling vertically
        el.addEventListener('wheel', onWheel, {passive: false});
        el.$athHorizontalWheelScroll = onWheel;
    },
    unbind: function (el) {
        if (!el.$athHorizontalWheelScroll) return;

        el.removeEventListener('wheel', el.$athHorizontalWheelScroll);
        el.$athHorizontalWheelScroll = undefined;
    },
};

/**
 * Bind the horizontal wheel scroll directive to Vue.
 * Use with `v-mead-horizontal-wheel-scroll`.
 */
const HorizontalWheelScrollDirective = {
    bind: function (vue) {
        vue.directive('meadHorizontalWheelScroll', HorizontalWheelScrollDir);
    }
}

export default HorizontalWheelScrollDirective;
